import React from 'react';
import { Box } from '@mui/material';

import GoogleCalendarAuthBanner from '../calendar/GoogleCalendarAuthBanner';
import ServiceAlertBanner from '../shared/ServiceAlertBanner';
import { dataSources, sourceArgs } from './dataSources';
import { useWidgetData } from './useWidgetData';

/** Fixed system banners between the greeting and the grid; faded while editing. */
export default function SystemBanners({ dim }) {
  const [key, fetch, options] = sourceArgs(dataSources.stats());
  const { data } = useWidgetData(key, fetch, options);
  const alerts = data?.service_alerts || [];
  return (
    <Box sx={{ opacity: dim ? 0.5 : 1, transition: 'opacity 0.2s ease' }}>
      <ServiceAlertBanner alerts={alerts} />
      <GoogleCalendarAuthBanner />
    </Box>
  );
}
